import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    EXERCISE_CALCULATION,
    EXERCISE_LOGIC,
    EXERCISE_MAGIC_BOX,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_PUZZLE_TASK,
    EXERCISE_SEQUENCE,
    EXERCISE_TASK
} from '@app/app.constants';

@Component({
    selector: 'app-profile-results-star-description',
    templateUrl: './profile-results-star-description.component.html',
    styleUrls: ['./profile-results-star-description.component.scss']
})
export class ProfileResultsStarDescriptionComponent {
    @Input() starImg: string;
    @Input() title: string;
    @Input() explanation: string;
    @Input() exercises: Array<any>;
    @Output() showModal = new EventEmitter();
    logic: string = EXERCISE_LOGIC;
    calculation: string = EXERCISE_CALCULATION;
    magic_box: string = EXERCISE_MAGIC_BOX;
    task: string = EXERCISE_TASK;
    sequence: string = EXERCISE_SEQUENCE;
    puzzle_task: string = EXERCISE_PUZZLE_TASK;

    puzzle_example: string = EXERCISE_PUZZLE_EXAMPLE;

    constructor() {}

    getTaskSpacingStyle(i) {
        return i > 0 ? '' : 'exercise-spacing';
    }

    getMagicBoxObject(string) {
        return JSON.parse(string);
    }

    getMagicBoxCellRight(exercise, row_index, elem_index) {
        return this.getMagicBoxObject(exercise.exercise_correct_answers[0].shortAnswer)[row_index][elem_index];
    }

    getMagicBoxCellWrong(exercise, row_index, elem_index) {
        return this.getMagicBoxObject(exercise.shortAnswer)[row_index][elem_index];
    }

    compareMagicBoxAnswers(exercise, row_index: number, elem_index: number) {
        if (
            this.getMagicBoxObject(exercise.shortAnswer)[row_index][elem_index] ===
            this.getMagicBoxObject(exercise.exercise_correct_answers[0].shortAnswer)[row_index][elem_index]
        ) {
            return true;
        }
        return false;
    }

    getMagicBoxTdStyle(elem, exercise, row_index, elem_index) {
        if (elem == null) {
            if (this.compareMagicBoxAnswers(exercise, row_index, elem_index)) {
                return 'magic-box-border-right';
            }
            return 'magic-box-border-wrong';
        }
        return '';
    }

    toogleShowModal() {
        this.showModal.emit();
    }
}
